<ng-container *ngIf="canShowLoader">
  <div class="loader-overlay">
    <div class="loader-overlay-content">
      <mat-spinner color="accent"
        [diameter]="diameter"></mat-spinner>
    </div>
  </div>
</ng-container>